import { Text } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { getTooltipContentByFieldName } from '../../../common/tooltip/tooltip-get-content';
import { MAX_QUESTIONNAIRE_CONTACT_FIELD_LENGTH } from '../../../models/schemas/questionnaire-wizard-validation.schema';
import { ValidationMessageList } from '../../shared-components';
import { FlexBox } from '../../shared-components/flex-box';
import { FormInput } from '../../shared-components/form';
import './ContactInformationSection.scss';

const ContactInformationSectionImpl: React.FC = () => {
  const {
    questionnaireWizardPageUiStore,
  } = useStores();

  const isBeingValidated = questionnaireWizardPageUiStore.isBeingValidated('contact');

  return (
    <>
      <FlexBox
        isFullWidth
        direction='column'
        className='contact-information-section'
      >
        <FlexBox
          isFullWidth
          aligns='start'
          className='contact-information-section__disclaimer'
        >
          <Text as='p' italic>Please complete all fields as soon as possible. Confirm public relations information</Text>
        </FlexBox>
        <FlexBox
          isFullWidth
          aligns='start'
          wrap
          className='contact-information-section__row'
        >
          <FormInput
            required
            label='Contact Name'
            validationMessage={
              isBeingValidated
              && questionnaireWizardPageUiStore.questionnaireContactValidation.fieldErrors.contactName?.length
                ? (
                  <ValidationMessageList
                    messages={questionnaireWizardPageUiStore.questionnaireContactValidation.fieldErrors.contactName}
                  />
                )
                : undefined
            }
            onChange={(contactName) => questionnaireWizardPageUiStore.setQuestionnaireContactField(
              {
                key: 'contactName',
                value: contactName,
              },
            )}
            inputProps={{
              type: 'text',
              maxLength: MAX_QUESTIONNAIRE_CONTACT_FIELD_LENGTH,
              value: questionnaireWizardPageUiStore.questionnaire.contact.contactName,
            }}
          />
          <FormInput
            required
            label='Company Name'
            tooltipText={getTooltipContentByFieldName('winner-questionnaire', 'companyName')}
            validationMessage={
              isBeingValidated
              && questionnaireWizardPageUiStore.questionnaireContactValidation.fieldErrors.companyName?.length
                ? (
                  <ValidationMessageList
                    messages={questionnaireWizardPageUiStore.questionnaireContactValidation.fieldErrors.companyName}
                  />
                )
                : undefined
            }
            onChange={(companyName) => questionnaireWizardPageUiStore.setQuestionnaireContactField(
              {
                key: 'companyName',
                value: companyName,
              },
            )}
            inputProps={{
              type: 'text',
              maxLength: MAX_QUESTIONNAIRE_CONTACT_FIELD_LENGTH,
              value: questionnaireWizardPageUiStore.questionnaire.contact.companyName,
            }}
          />
        </FlexBox>
        <FlexBox
          isFullWidth
          aligns='start'
          className='contact-information-section__row'
        >
          <FormInput
            required
            label='Company Website'
            validationMessage={
              isBeingValidated
              && questionnaireWizardPageUiStore.questionnaireContactValidation.fieldErrors.companyWebsite?.length
                ? (
                  <ValidationMessageList
                    messages={questionnaireWizardPageUiStore.questionnaireContactValidation.fieldErrors.companyWebsite}
                  />
                )
                : undefined
            }
            onChange={(companyWebsite) => questionnaireWizardPageUiStore.setQuestionnaireContactField(
              {
                key: 'companyWebsite',
                value: companyWebsite,
              },
            )}
            inputProps={{
              type: 'text',
              maxLength: MAX_QUESTIONNAIRE_CONTACT_FIELD_LENGTH,
              value: questionnaireWizardPageUiStore.questionnaire.contact.companyWebsite,
            }}
          />
        </FlexBox>
      </FlexBox>
    </>
  );
}

export const ContactInformationSection = observer(ContactInformationSectionImpl);
